import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';

import { H3, Button, Icon } from '../../../../../components';

const NoAssetsContainer = styled.div`
  padding: 20px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 32px;
  border-radius: 20px;
  border: 1px solid var(--border-muted);
  margin: 32px 10px 0;
  background: var(--elevation-high);
  box-sizing: border-box;
`;

const StyledColumn = styled(Col)`
  @media (max-width: 768px) {
    display: 'flex';
    justify-content: 'center';
  }
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

const NoAssets = ({ className = null, onCreateChatClick }) => (
  <Row center='xs'>
    <StyledColumn xs={12} lg={8}>
      <NoAssetsContainer className={className}>
        <LabelContainer>
          <H3>Ready to begin?</H3>
          <H3>Start a new chat or save an existing asset</H3>
        </LabelContainer>
        <Button primary onClick={onCreateChatClick}>
          <Icon name='qa' />
          Start a new chat
        </Button>
      </NoAssetsContainer>
    </StyledColumn>
  </Row>
);

NoAssets.propTypes = {
  onCreateChatClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export { NoAssets };
